const validEmail = input => {
  return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/gi).test(input)
}

export default validEmail
